<div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (list.length){
        @for (item of list;track $index){
            <li >{{ item }}</li>
        }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">{{ closeBtnName }}</button>
  </div>
